import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { Colors, Icon, Typography } from '@zapier/design-system';

import { mediaQueries } from '@zapier/identity-utils';

type FeatureItemProps = {
  children: ReactNode;
};

const listItemStyles = css`
  display: flex;
  gap: 10px;
  text-align: start;

  gap: 8px;
  align-items: center;
  ${mediaQueries.desktop} {
    gap: 15px;
  }
`;

const listItemTextStyles = css`
  ${mediaQueries.tablet} {
    ${Typography.paragraph3}
    color: ${Colors.neutral700};
  }
  ${mediaQueries.desktop} {
    ${Typography.paragraph1}
    color: ${Colors.neutral700};
    line-height: ${Typography.paragraph1.lineHeight};
  }
`;

export function FeatureItem({ children }: FeatureItemProps) {
  return (
    <li css={[listItemStyles]}>
      <Icon color={'success400'} name="formCheckCircle" size={20} />
      <span css={listItemTextStyles}>{children}</span>
    </li>
  );
}
